// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --curve-comfortable-entrance: cubic-bezier(0.5, 0.1, 0.25, 1);
  --curve-comfortable-exit: cubic-bezier(0.62, 0.05, 0.32, 1);
  --curve-expressive-entrance: cubic-bezier(0.75, 0.25, 0, 1);
  --curve-expressive-exit: cubic-bezier(0.63, 0.85, 0, 1);
  --duration-fast-01: 100ms;
  --duration-fast-02: 160ms;
  --duration-moderate-01: 240ms;
  --duration-moderate-02: 320ms;
  --duration-slow-01: 400ms;
  --duration-slow-02: 600ms;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-tokens/dist/web/globals/motion.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,2DAA2D;EAC3D,2DAA2D;EAC3D,uDAAuD;EACvD,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[":root {\n  --curve-comfortable-entrance: cubic-bezier(0.5, 0.1, 0.25, 1);\n  --curve-comfortable-exit: cubic-bezier(0.62, 0.05, 0.32, 1);\n  --curve-expressive-entrance: cubic-bezier(0.75, 0.25, 0, 1);\n  --curve-expressive-exit: cubic-bezier(0.63, 0.85, 0, 1);\n  --duration-fast-01: 100ms;\n  --duration-fast-02: 160ms;\n  --duration-moderate-01: 240ms;\n  --duration-moderate-02: 320ms;\n  --duration-slow-01: 400ms;\n  --duration-slow-02: 600ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
